export const formatWasteTypeId = (wasteTypeId: string | number): string => {
  const stringWasteTypeId = String(wasteTypeId);

  return stringWasteTypeId.match(/.{1,2}/g)?.join("-") || stringWasteTypeId;
};
